import React from "react";
import "../css/style.css";
import Button from "@mui/material/Button";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import i18next from "i18next";


export default function RoomRentItem(props) {

  const { number, description,equipment,seats, time_from, time_to, price_hour, price_day, index, isClosed } = props;
 
  return (
     <div style={{display:'flex',flex:1,marginBottom:10}}>
		<div className="form__col">
				<div className="form__group">
					 <div style={{display:'flex',flex:1}}>
				  <div style={{marginRight:5, fontSize:20}}>{index+1}.</div>
				<div className="title-small" onClick={()=>props.clickExpand(index)}>
				  	{!isClosed ? <ExpandLess  fontSize="medium"/> : 
									<ExpandMore  fontSize="medium"/>}
					</div>
                    <span>
					{number}
					</span>
                    </div>
				 
				</div>
                  
				  
				  <Collapse in={!isClosed} timeout="auto" >
				 <div className="form__group">
					<div>{i18next.t("room_description")}: {description?description:i18next.t("no_data")}</div>

				  <div style={{marginTop:5}}>{i18next.t("equipment")}: {equipment?equipment:i18next.t("no_data")}</div>
				    <div style={{marginTop:5}}>{i18next.t("room_seats")}: {seats?seats:i18next.t("no_data")}</div>
				  </div>

				  <div className="form__group">
				  <div style={{fontSize:16, fontWeight:800}}>{i18next.t("rent_time_price")}</div>
				  <div style={{display:'flex',flex:1, marginTop:10}}>
				  <div style={{marginRight:5,minWidth:200, paddingTop:10}}>{i18next.t("time_start")}: {time_from?time_from:i18next.t("no_data")}</div>
                  </div>
					<div style={{display:'flex',flex:1}}>
					<div style={{marginRight:5,minWidth:200, paddingTop:10}}>{i18next.t("time_end")}: {time_to?time_to:i18next.t("no_data")}</div>
                    </div>
					<div style={{display:'flex',flex:1}}>
					<div style={{marginRight:5,minWidth:200, paddingTop:10}}>{i18next.t("price_per_hour")}: {price_hour?price_hour:i18next.t("no_data")}</div>
                    </div>
					<div style={{display:'flex',flex:1}}>
					<div style={{marginRight:5,minWidth:200, paddingTop:10}}>{i18next.t("price_per_day")}: {price_day?price_day:i18next.t("no_data")}</div>
                    </div>
				  </div>
				  <div style={{display:'flex',flex:1,marginBottom:20}}>
					<Button style={{marginRight:20}} variant="contained" onClick={()=>props.bookRoom(index)}>{i18next.t("book_room")}</Button>
					</div>
				</Collapse>	
		</div>
	</div>
  );
}


